import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosConfig';
import { useToast } from '../../context/toastContext';
import { useAlert } from '../../context/AlertContext';
import { useTranslation } from 'react-i18next';
import { ClipLoader } from 'react-spinners';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const role = searchParams.get('role');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { t } = useTranslation();
  const addToast = useToast();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !role) {
      // addToast(t('auth.invalid_link'), 'error');
      showAlert({
        title: t('alert_dialog.reset_password.invalid_link_title'),
        message: t('alert_dialog.reset_password.invalid_link_message'),
        primaryAction: {
          label: t('alert_dialog.reset_password.invalid_link_primary_action'),
        },
      });
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, role]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      addToast(t('auth.passwords_do_not_match'), 'error');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/auth/reset-password', { token, role, password });
      // addToast(t('auth.password_reset_success'), 'success');
      showAlert({
        title: t('alert_dialog.reset_password.success_title'),
        message: t('alert_dialog.reset_password.success_message'),
        primaryAction: {
          label: t('alert_dialog.reset_password.success_primary_action'),
        },
      });
      navigate('/');
    } catch (err) {
      showAlert({
        title: t('alert_dialog.reset_password.error_title'),
        message: t('alert_dialog.reset_password.error_message'),
        primaryAction: {
          label: t('alert_dialog.reset_password.error_primary_action'),
        },
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-xl animate-fadeIn">
        <h1 className="text-3xl font-bold text-gray-800 text-center mb-6">
          {t('login.reset_password_title')}
        </h1>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <input
              type="password"
              placeholder={t('login.new_password')}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div>
            <input
              type="password"
              placeholder={t('login.confirm_password')}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-yellow-400 focus:outline-none"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ? (
              <ClipLoader color="#fff" size={20} />
            ) : (
              t('login.confirm_reset')
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
